<template>
    <div class="w3l bottom-picture">
        <div class="overlay-w3l mid-content">
            <pre class="bottom-para">{{ authorsText }}</pre>
        </div>
    </div>
    <div class="bottom-subscribe">
        <a href="https://epaper.ncu.edu.tw/subscribe?pid=46" target="_blank"><b>訂閱本報</b></a>
        <div class="sub-gd">
            <a v-if="pathId == '/'" :href="`http://www.facebook.com/sharer.php?u=http://hakka.ncu.edu.tw/Hakka_ePaper/paper/paper${paperId}`"
                class="icon-social"><img src="http://hakka.ncu.edu.tw/Hakka_ePaper/paper/social/facebook512.png" alt="Facebook" width="30" height="30"></a>
            <a v-else :href="`http://www.facebook.com/sharer.php?u=http://hakka.ncu.edu.tw/Hakka_ePaper/paper/paper${paperId}${pathId}`"
                class="icon-social"><img src="http://hakka.ncu.edu.tw/Hakka_ePaper/paper/social/facebook512.png" alt="Facebook" width="30" height="30"></a>
            <a v-if="pathId == '/'" :href="`http://twitter.com/share?url=http://hakka.ncu.edu.tw/Hakka_ePaper/paper/paper${paperId}`"
                class="icon-social"><img src="http://hakka.ncu.edu.tw/Hakka_ePaper/paper/social/twitter512.png" alt="twitter" width="30" height="30"></a>
            <a v-else :href="`http://twitter.com/share?url=http://hakka.ncu.edu.tw/Hakka_ePaper/paper/paper${paperId}${pathId}`"
                class="icon-social"><img src="http://hakka.ncu.edu.tw/Hakka_ePaper/paper/social/twitter512.png" alt="twitter" width="30" height="30"></a>
            <a v-if="pathId == '/'" :href="`http://line.naver.jp/R/msg/text/?http://hakka.ncu.edu.tw/Hakka_ePaper/paper/paper${paperId}`"
                class="icon-social"><img src="http://hakka.ncu.edu.tw/Hakka_ePaper/paper/social/line512.png" alt="line" width="30" height="30"></a>
            <a v-else :href="`http://line.naver.jp/R/msg/text/?http://hakka.ncu.edu.tw/Hakka_ePaper/paper/paper${paperId}${pathId}`"
                class="icon-social"><img src="http://hakka.ncu.edu.tw/Hakka_ePaper/paper/social/line512.png" alt="line" width="30" height="30"></a>
        </div>
        <hr>
        <div>
            <p class="bottom-edit">&copy; 2025 New Edition Design by 客家系</p>
        </div>
    </div>
</template>

<script>
import authorsText from '../../authors.txt';

export default {
    name: 'BannerBottom',
    computed: {
        pathId() {
            return this.$route.path;
        },
    },
    data() {
        return {
            paperId: process.env.VUE_APP_PAPER_ID,
            authorsText
        }
    },
}
</script>
<style scoped>
.w3l {
    position: relative;
    z-index: 0;
}

.bottom-picture {
    background-image: url('@/assets/BOT.jpg');
    background-size: cover;
    position: relative;
    background-position: center;
}

@media screen and (min-width: 737px) {
    .overlay-w3l {
        background: rgba(10, 9, 9, 0.6396156862745098);
        z-index: 9;
        padding: 4em 2em;
        text-align: left;
        width: 46%;
        margin-right: auto;
        margin-left: 35px;
    }
}

@media screen and (max-width:736px) {
    .overlay-w3l {
        background: rgba(10, 9, 9, 0.6396156862745098);
        z-index: 9;
        padding: 3em 1.5em;
    }
}

.bottom-para {
    padding: 0px !important;
    font-size: 14px;
    margin: 20px 0;
    text-align: left;
    color: #ffffff;
    line-height: 26px;
    white-space: break-spaces;
    font-family: inherit;
    font-weight: 600;
}

.bottom-subscribe {
    font-size: 20px;
    color: #777;
    margin: 0 auto;
    padding: 30px;
}

.icon-social {
    display: inline-block;
    margin: 10px;
}

.bottom-edit {
    color: #777;
    font-size: 14px;
    text-align: left;
}
</style>
